import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card } from "react-bootstrap";

function DivePage() {
    return (<>
        <Navbar />
        <Card>
            <Card.Header>Richtig Schnorcheln und Tauchen</Card.Header>
            <Card.Body>
                <Card.Text>
                    Tauchen und Schnorcheln zählen zu den faszinierendsten Aktivitäten in der Natur. Dabei bewegen wir uns jedoch in einer Umgebung, die für den Menschen herausfordernd ist.
                    <br /><br />
                    Eine solide Ausbildung ist daher essenziell. Regelmäßiges Training stärkt die Kondition, verbessert die Fähigkeiten und erhöht die Sicherheit. Der Schutz der Unterwasserwelt und die Freude am Sport hängen eng mit unserer Erfahrung zusammen. Wer sicher schnorchelt oder taucht, genießt den Urlaub am Meer oder See umso mehr.
                    <br /><br />
                    Wir bieten eine umfassende Ausbildung ohne Zeitdruck und zu fairen Kosten. Falls nötig, kann die Ausrüstung bei uns ausgeliehen werden.
                    <br /><br />
                    Weitere Informationen zu Tauchscheinen (Brevets) und Zusatzkursen findest du auf der Seite des <a href="https://vdst.de">VDST</a>.
                </Card.Text>
            </Card.Body>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>)
}

export default DivePage;